var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.chunks),function(chunk,index){return _c('span',{key:index,class:chunk[1] ? 'highlight' : ''},[_vm._v(_vm._s(chunk[0]))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }